import React from "react";
import { FormattedMessage, injectIntl, defineMessages } from "react-intl";
class Tabs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: this.props.children[0].props.label
        };
        this.changeTab = this.changeTab.bind(this);
    }
    changeTab = (tab) => {
        this.setState({ activeTab: tab });
    };
    render() {
        let content;
        let buttons = [];
        return (
            <div>
                {React.Children.map(this.props.children, child => {
                    buttons.push(child.props.label)
                    if (child.props.label === this.state.activeTab) content = child.props.children
                })}

                <TabButtons activeTab={this.state.activeTab} buttons={buttons} changeTab={this.changeTab} />
                <div className="tab-content">{content}</div>

            </div>
        );
    }
}
const TabButtons = ({ buttons, changeTab, activeTab }) => {
    return (
        <div className="tab-buttons">
            {buttons.map((button, idx) => {
                return <button key={idx} className={button === activeTab ? 'active' : ''} onClick={() => changeTab(button)}>{button}</button>
            })}
        </div>
    )
}

export default injectIntl(Tabs);